import React, { useState, useRef, useEffect } from 'react';

interface DropdownProps {
  title: React.ReactNode;
  children: React.ReactNode;
}

export const Dropdown = ({ title, children }: DropdownProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [maxHeight, setMaxHeight] = useState('0px');
  const contentRef = useRef<HTMLDivElement | null>(null);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (isOpen && contentRef.current) {
      setMaxHeight(`${contentRef.current.scrollHeight}px`);
    } else {
      setMaxHeight('0px');
    }
  }, [isOpen]);

  return (
    <div className="w-full">
      <div
        className="cursor-pointer flex justify-between items-center border-b border-black pt-[26px] pb-0"
        onClick={toggleDropdown}
      >
        <span className="-mb-[10px]">{title}</span>
        <span className="mx-4 scale-150">{isOpen ? '-' : '+'}</span>
      </div>

      <div
        ref={contentRef}
        className="overflow-hidden transition-max-height duration-500 ease-in-out"
        style={{ maxHeight }}
      >
        <div className="py-4">{children}</div>
      </div>
    </div>
  );
};
